import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function parallax() {
  // textSectionを取得
  const paraSections = document.querySelectorAll(".js-parallax");

  paraSections.forEach((paraItem) => {
    const y = "-15%";
    const delay = 0.5;
    const img = paraItem.querySelector("img"); // itemの中にあるimg要素を取得

    let parallaxPosition = paraItem.dataset.parallaxposition;

    if (!parallaxPosition) {
      parallaxPosition = "-30%";
    }

    gsap.fromTo(
      // gsap.fromToでアニメーションを設定
      img, // 対象の要素をimgで指定
      {
        y: parallaxPosition, // アニメーション開始時のy位置
      },
      {
        y: y, // アニメーション終了時のy位置
        scrollTrigger: {
          // スクロールトリガーを設定
          trigger: paraItem, // itemをトリガーとなる要素として指定
          start: "top bottom", // 要素の上端がビューポートの下端に達したときに開始
          end: "bottom top", // 要素の下端がビューポートの上端に達したときに終了
          scrub: delay, // スクロールに追従してアニメーションを行う（デフォルトでは1秒の遅延）
        },
        ease: "none", // イージング関数を指定しない（線形アニメーション）
      }
    );
  });
}
